import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partnership_program: {
        creatives: {
          tabs: {
            link: 'TAB_LINK',
            jpeg: 'TAB_JPEG',
            png: 'TAB_PNG',
            gif: 'TAB_GIF',
            bannerflow_gif: 'TAB_BANNERFLOW_GIF',
            iframe: 'TAB_IFRAME',
            // flash: 'TAB_FLASH',
          },
          modal_window: {
            change_creative_state: {
              set_active_title: 'SET_ACTIVE_TITLE',
              set_unactive_title: 'SET_UNACTIVE_TITLE',
              list_of_creative_ids: 'LIST_OF_CREATIVE_IDS',
              no_one_creative_has_been_chosen: 'NO_CREATIVE_CHOSEN',
              apply_changes_button: 'APPLY_CHANGES',
              cancel_button: 'CANCEL_BUTTON',
            },
          },
          settings: {
            form: {
              common: {
                format: 'FORM_FORMAT',
                title: 'FORM_TITLE',
                advertising_company: 'FORM_COMPANY',
                language: 'FORM_LANGUAGE',
                status: 'FORM_STATUS',
                at_beginning_show: 'FORM_AT_BEGINNING_SHOW',
                at_end_show: 'FORM_AT_END_SHOW',
                link: 'FORM_LINK',
                exclusive_affiliates: 'FORM_EXCLUSIVE_AFFILIATES',
                choose_file: 'FORM_CHOOSE_FILE',
                bulk_upload_label: 'FORM_BULK_UPLOAD_LABEL',
                bulk_upload: {
                  drop_file_here: 'BULK_DROP_FILES_HERE',
                  file_name: 'BULK_FILE_NAME',
                  file_format: 'BULK_FILE_FORMAT',
                  file_size: 'BULK_FILE_SIZE',
                  file_resolution: 'BULK_FILE_RESOLUTION',
                  file_ready: 'BULK_FILE_READY',
                  file_status: 'BULK_FILE_STATUS',
                  file_not_valid: 'BULK_FILE_NOT_VALID',
                },
                transfer_additional_request_parameters: {
                  label: 'TRANSFER_ADDITIONAL_REQUEST_PARAMETERS_LABEL',
                  yes: 'TRANSFER_ADDITIONAL_REQUEST_PARAMETERS_OPTION_YES',
                  no: 'TRANSFER_ADDITIONAL_REQUEST_PARAMETERS_OPTION_NO',
                },
              },
              bannerflow_gif: {
                link: 'BANNER_LINK',
                iframe_body: 'BANNER_IFRAME_BODY',
                iframe_width: 'BANNER_IFRAME_WIDTH',
                iframe_height: 'BANNER_IFRAME_HEIGHT',
              },
              iframe: {
                link: 'IFRAME_LINK',
                iframe_body: 'IFRAME_IFRAME_BODY',
                iframe_width: 'IFRAME_IFRAME_WIDTH',
                iframe_height: 'IFRAME_IFRAME_HEIGHT',
              },
              // flash: {
              //   drop_file_here: 'FLASH_DROP_FILES_HERE'
              // },
              gif: {
                resolution_file: 'GIF_RESOLUTION_FILE',
                drop_file_here: 'GIF_DROP_FILES_HERE',
              },
              jpeg: {
                resolution_file: 'JPEG_RESOLUTION_FILE',
                drop_file_here: 'JPEG_DROP_FILES_HERE',
              },
              png: {
                resolution_file: 'PNG_RESOLUTION_FILE',
                drop_file_here: 'PNG_DROP_FILES_HERE',
              },
            },
            edit_title: 'EDIT_TITLE',
            create_title: 'CREATE_TITLE',
            status_active: 'STATUS_ACTIVE',
            status_not_active: 'STATUS_NOT_ACTIVE',
            status_archived: 'STATUS_ARCHIVED',
            status_common: 'STATUS_COMMON',
            create_submit: 'CRATE_SUBMIT',
            edit_submit: 'EDIT_SUBMIT',
            bulk_upload_description: 'BULK_UPLOAD_DESCRIPTION',
            upload_file_description: 'UPLOAD_FILE_DESCRIPTION',
            back: 'SETTINGS_BACK',
          },
          submit: 'SUBMIT',
          create_bulk: 'CREATE_BULK',
          set_creatives_activated: 'SET_ACTIVATED',
          set_creatives_unactivated: 'SET_UNACTIVATED',
          archive_creative: 'ARCHIVE',
          unarchive_creative: 'UNARCHIVE',
          header: 'HEADER',
        },
      },
    },
  }));
}
